import {
  ServiceOrganizationFieldGroupProps,
  ServiceOrganizationFieldGroupTemplate,
} from '@gasbi/shared/common/components';

import { useGetServiceOrganizationsInfiniteQuery } from '@/features/serviceOrganizationsApi';

export const ServiceOrganizationFieldGroup = (
  props: Omit<ServiceOrganizationFieldGroupProps, 'queryHook'>,
) => (
  <ServiceOrganizationFieldGroupTemplate
    {...props}
    queryHook={useGetServiceOrganizationsInfiniteQuery}
  />
);
